import { render, staticRenderFns } from "./ResourceWidgetTemplate.vue?vue&type=template&id=72ff7bb8&scoped=true"
import script from "./ResourceWidgetTemplate.vue?vue&type=script&lang=js"
export * from "./ResourceWidgetTemplate.vue?vue&type=script&lang=js"
import style0 from "./ResourceWidgetTemplate.vue?vue&type=style&index=0&id=72ff7bb8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72ff7bb8",
  null
  
)

export default component.exports